export default __webpack_public_path__ + "media/src/shared/assets/errorIcon-f955cba1ea35f07b002d4ee7d78466d5.svg";